import { render, staticRenderFns } from "./CampaignPerformances.vue?vue&type=template&id=31d9d781&scoped=true&"
import script from "./CampaignPerformances.vue?vue&type=script&lang=ts&"
export * from "./CampaignPerformances.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignPerformances.vue?vue&type=style&index=0&id=31d9d781&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9d781",
  null
  
)

export default component.exports